import { render, staticRenderFns } from "./DproductView.vue?vue&type=template&id=fb4f1ad0&scoped=true"
import script from "./DproductView.vue?vue&type=script&lang=js"
export * from "./DproductView.vue?vue&type=script&lang=js"
import style0 from "./DproductView.vue?vue&type=style&index=0&id=fb4f1ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4f1ad0",
  null
  
)

export default component.exports